var React = require('react');

function TitledDot (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Oval 2 Copy"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Desktop-HD-Copy","transform":"translate(-1087.000000, -419.000000)","fill":"#00A093"},React.createElement("g",{"id":"Group-14-Copy","transform":"translate(874.000000, 270.000000)"},React.createElement("g",{"id":"Group-12","transform":"translate(160.859155, 137.000000)"},React.createElement("ellipse",{"id":"Oval-2-Copy","cx":"57.0422535","cy":"16","rx":"4.56338028","ry":"4"})))))]);
}

TitledDot.defaultProps = {"width":"10px","height":"8px","viewBox":"0 0 10 8","version":"1.1"};

module.exports = TitledDot;

TitledDot.default = TitledDot;
